import { RootState } from "../Store";

export const SELECT_NOTIFICATIONS = (state: RootState) =>
  state.notificationsSlice.ALL_NOTIFICATIONS;

export const SELECT_NOTIFICATIONS_COUNT = (state: RootState) =>
  state.notificationsSlice.COUNT_NOTIFICATIONS;
